import { SettlementTargetDto, SettlementTargetDtoTypeEnum } from 'src/Services/API/generated';

/**
 * Nom court d'une cible de solde : prénom pour une personne, libellé du compte
 * pour un compte bancaire. Jamais de concaténation firstName + lastName ici — la
 * liste « Dû par … » se lit d'un coup d'œil et les noms de famille l'alourdissent.
 */
export const formatSettlementTargetName = (
  target: Pick<SettlementTargetDto, 'type' | 'firstName' | 'displayName' | 'name'>
): string => {
  if (target.type === SettlementTargetDtoTypeEnum.BankAccount) return target.name ?? '';
  return target.firstName ?? target.displayName ?? target.name ?? '';
};
